import React from 'react';
import HeroSection from './hero-section'
import CallSection from '../call-section'
import TellUs from './tell-us'
import LearnAboutAddiction from './learn-about-addiction'
import FindrehabCenters from '../find-rehab-centers'
import ContactUs from './contact-us'
const Home = () => {
  return (
    <>
      <HeroSection />
      <CallSection />
      <TellUs/>
      <LearnAboutAddiction/>
      <FindrehabCenters page="Home"/>
      <ContactUs/>
    </>
  );
};

export default Home;
